export var LABEL_SIZES = {
  md: 'md',
  lg: 'lg'
};